import spinnerHtmlString from '../../assets/html/fullScreenSpinnerLoader.html?raw';

let spinnerElem: HTMLDivElement | undefined;
let timeoutId: ReturnType<typeof setTimeout>;
const TIMEOUT_MS = 25000; // Time to avoid being stuck in the loading spinner
export const setSpinnerVisibility = async (show: boolean, text?: string) =>
  new Promise((resolve) => {
    clearTimeout(timeoutId);
    if (show) {
      spinnerElem = document.createElement('div');
      spinnerElem.innerHTML = spinnerHtmlString;
      const descriptionElem = spinnerElem.querySelector('#loading-page .description');
      spinnerElem.classList.add('loading-fade-in');
      if (descriptionElem && text) {
        descriptionElem.innerHTML = text;
      }

      document.body.prepend(spinnerElem);

      timeoutId = setTimeout(async () => {
        await setSpinnerVisibility(false, text);
      }, TIMEOUT_MS);

      resolve(true);
    } else if (spinnerElem) {
      spinnerElem.classList.add('loading-fade-out');
      spinnerElem.addEventListener('animationend', () => {
        if (spinnerElem) {
          spinnerElem.classList.remove('loading-fade-in');
          spinnerElem.remove();
        }

        resolve(true);
      });
    } else {
      resolve(true);
    }
  });
